import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase/app"; 
import 'firebase/database'
import axios from 'axios'

Vue.use(Vuex);
Vue.use(require('vue-moment')); // move this somewhere else maybe?

export default new Vuex.Store({
  // default statte
  state: {
    user: {
      loggedIn: false,
      data: undefined,
      profile: {
        proMembership: { 
          status: "unknown",
          isActive: false
        }
      }
    },
    userProfileListener: null,
    userProfileListenerUserId: null
  },
  getters: {
    user(state){
      return state.user
    },
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.data = data;
    },
    SET_USER_PROFILE(state, value) {
      if (value != null) {
        state.user.profile = value;
      }
    },
    SET_USER_PROFILE_LISTENER(state, { listener, userId }) {
      state.userProfileListener = listener;
      state.userProfileListenerUserId = userId;
    }
  },
  actions: {
    fetchUser({ commit, state }, user) {
      commit("SET_LOGGED_IN", user !== null);
      if (user) {
        // Clean up any existing listener BEFORE committing new user data
        // Use the stored userId where the listener was actually attached
        if (state.userProfileListener && state.userProfileListenerUserId) {
          firebase.database().ref('/users/' + state.userProfileListenerUserId).off('value', state.userProfileListener);
        }

        commit("SET_USER", {
          displayName: user.displayName,
          email: user.email,
          uid: user.uid
        });

        // Set up real-time listener for user profile
        this.dispatch("listenToUserProfile", user.uid)
      } else {
        // Clean up listener on logout
        // Use the stored userId where the listener was actually attached
        if (state.userProfileListener && state.userProfileListenerUserId) {
          firebase.database().ref('/users/' + state.userProfileListenerUserId).off('value', state.userProfileListener);
        }
        commit("SET_USER_PROFILE_LISTENER", { listener: null, userId: null });
        commit("SET_USER", null);
      }
    },
    listenToUserProfile({commit}, userId) {
        const profileRef = firebase.database().ref('/users/' + userId);
        const listener = profileRef.on('value', function(snapshot) {
            commit("SET_USER_PROFILE", snapshot.val())
        });
        commit("SET_USER_PROFILE_LISTENER", { listener, userId });
    },
    fetchUserProfile({commit}, userId) {
        return firebase.database().ref('/users/' + userId).once('value').then(function(snapshot) {
            commit("SET_USER_PROFILE", snapshot.val())
        });
        
    },
    createCheckoutPage({commit}, {user, trialDuration, planId}) {
      return new Promise((resolve, reject) => {
          axios.post(process.env.VUE_APP_CF_CREATE_CHECKOUT_URL, {
            "data": { 
              "userId": user.data.uid,
              "trialDuration": trialDuration,
              "priceId": planId
            }
          }).then((res) =>  {
            resolve(res)
          }).catch((error) => {
            reject(error)
          });
      })
    },
    createCustomerPortalPage({commit}, {customerId}) {
      return new Promise((resolve, reject) => {
          axios.post(process.env.VUE_APP_CF_CREATE_CUSTOMER_PAGE_URL, {
            "data": { 
              "customerId": customerId,
            }
          }).then((res) =>  {
            resolve(res)
          }).catch((error) => {
            reject(error)
          });
      })
    }

  }
});